import React, { Component } from 'react';
import { read as readXsl, utils as xslUtils } from 'xlsx';
import { v4 as uuid } from 'uuid';
import moment from 'moment';

import { AuthContext } from "../../../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../../../api/apiUtil.jsx";
import ldsApi from "../../../../api/ldsApi.jsx";
import wmsApi from "../../../../api/wmsApi.jsx";
import Api from "../../../../api/api.jsx";
import Geocode from "react-geocode";

import { 
  Box,
  Grid,
  IconButton,
  CircularProgress,
} from '@material-ui/core';

import { ReactComponent as DeleteIcon } from '../../../../assets/img/icons/delete.svg';

import CustomInput from '../../../../components/CustomFields/CustomInput.jsx';
import CustomSelectOption from '../../../../components/CustomFields/CustomSelectOption.jsx';
import CustomLabel from '../../../../components/CustomFields/CustomLabel.jsx';
import CustomButton from '../../../../components/CustomFields/CustomButton.jsx';
import CustomCheckbox from '../../../../components/CustomFields/CustomCheckbox.jsx';
import CustomGoogleMapSearch from '../../../../components/GoogleMap/CustomGoogleMapSearch.jsx';
import CustomAlert from '../../../../components/Alert/CustomAlert.jsx';
import Table from '../../../../components/Table/Table.jsx';
import {RoleAccessService} from '../../../../data/role-access'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const DataFieldType = {
    Job: 1,
    Step: 2,
    Item: 3,
}

const { 
    REACT_APP_GOOGLE_MAP_API_KEY,
  } = process.env;

export class JobImportDialog extends Component {
  static contextType = AuthContext;
  
  constructor(props){
    super(props);

    let formatTime = localStorage.getItem('Time Format') ? localStorage.getItem('Time Format') : '12-Hour';
    let timeFormat = (formatTime === '12-Hour') ? 'hh:mm A' : 'HH:mm';
    this.refForm = React.createRef();
    let isLoading = ((props.isLoading === true || props.isLoading === false) ? props.isLoading : false);
    let file = (props.file) ? props.file : null;
    let dataFields = [
        { label: 'First name', value: 'First name', col: 'first_name', required: true, disabled: false, dataType: 'string' },
        { label: 'Vehicle number', value: 'Vehicle number', col: 'vehicle_number', required: true, disabled: false, dataType: 'string' },
        { label: 'Vehicle type', value: 'Vehicle type', col: 'vehicle_type', required: true, disabled: false, dataType: 'string' },
        { label: 'Category', value: 'Category', col: 'category', required: true, disabled: false, dataType: 'string' },
        { label: 'Mobile number', value: 'Mobile number', col: 'mobile_number', required: true, disabled: false, dataType: 'string' },
        { label: 'Preferred payment method', value: 'Preferred payment method', col: 'preferred_payment_method', required: true, disabled: false, dataType: 'string' },
        { label: 'PayNow / PayLah / Bank Account Number', value: 'PayNow / PayLah / Bank Account Number', col: 'bank_account_number', required: true, disabled: false, dataType: 'string' },
        { label: 'Username', value: 'Username', col: 'username', required: true, disabled: false, dataType: 'string' },
        { label: 'Password', value: 'Password', col: 'password', required: true, disabled: false, dataType: 'string' },
        { label: 'Driver profile', value: 'Driver profile', col: 'driver_profile', required: true, disabled: false, dataType: 'string' },
        { label: 'Available hours (start)', value: 'Available hours (start)', col: 'available_hour_from', required: true, disabled: false, dataType: 'string' },
        { label: 'Available hours (end)', value: 'Available hours (end)', col: 'available_hour_to', required: true, disabled: false, dataType: 'string' },
        ];
    const grantedAccess = new RoleAccessService();
    const currentRole = window.localStorage.getItem('current_role') || null;
    this.dataFieldsPom = JSON.parse(JSON.stringify(dataFields));

    this.state = {
        isLoading: isLoading,
        grantedAccess : grantedAccess,
        file: file,
        importedSheetData: [],
        headers: [],
        excelRows: [],

        dataFields: dataFields,

        columns: [],
        rows: [],

        isLoadingSteps: false,
        columnsSteps: [],
        rowsSteps: [],

        isLoadingItems: false,
        columnsItems: [],
        rowsItems: [],

        status: [],
        isLoadingInitCalls: true,

        refresh: false,

        timeFormat: timeFormat,

        isLoadingAppSettings: false,
        rule: null,
        errMessages: [],
        isFirstTime: false,
    }
  }
  

  componentDidMount() {
    if(this.state.file){
        this.loadWorkSheet(); 
    } else {
        if(this.props.onClose){
            this.props.onClose();
        }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading !== this.state.isLoading) {
        let isLoading = ((nextProps.isLoading === true || nextProps.isLoading === false) ? nextProps.isLoading : false);
        this.setState({
            isLoading: isLoading
        });
    }
    if (nextProps.file !== this.state.file) {
        let file = (nextProps.file) ? nextProps.file : null;
        this.setState({
            file: file
        });
    }
  }

  /* FUNCTIONS */
  loadWorkSheet = () => {
    if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
            reader.onload = (e) => {
                let wb = readXsl(reader.result, {type: 'binary'});
                
                let wsname = wb.SheetNames[0];
                let ws = wb.Sheets[wsname];
               
                let data = xslUtils.sheet_to_json(ws, { defval: null, raw: false, header: 1 });

                let filteredData = data.filter(function (el) {
                  return el[0] !== null || el[1] !== null || el[2] !== null || el[3] !== null || el[4] !== null || el[5] !== null || el[6] !== null || el[7] !== null || el[8] !== null || el[9] !== null;
                });

                this.setState({
                    importedSheetData: filteredData,
                }, () => {
                    this.initColumns();
                });
            };
            reader.readAsBinaryString(this.state.file);
        }
    } else {
        console.log("This browser does not support HTML5.");
    }
  }
  
  unRequiredFileldUti = (field, reqiredStatus) => {
    let unRequiredFilelds = ['Company name','Recipient name','Job description', 'Company code'];
    let status = unRequiredFilelds.includes(field)? false : reqiredStatus;
    return status ;
  }


  initColumns = () => {
    let { isCustomerRequired } = this.context;
    let columns = [];
    let headers = [];

    if(this.state.importedSheetData && this.state.importedSheetData.length > 0){
        let heads = this.state.importedSheetData[0];
        headers = heads.map((head, i) => {
            let labelItem = this.state.dataFields.filter(x => x.value === head);

            return {
                value: head,
                label: (labelItem && labelItem.length > 0) ? labelItem[0].label : head,
                disabled: false,
            }
        });
    }

    this.state.dataFields.map((feild, i) => {
        let headerIndex = headers.findIndex(x => x.value === feild.value);
        if(headerIndex !== -1){
            headers[headerIndex].disabled = true;
            feild.selected = (feild.value && feild.value !== '') ? feild.value : '';
            feild.disabled = true;
        }

        columns.push({ 
            field: (feild.selected && feild.selected !== '') ? feild.selected : '',
            realField: feild.value,
            title: feild.label,
            required: feild.required,
            width: 200,
            sorting: false,
            searchable: false,
            grouping: false,
            filtering: false,
            render: (row, type) => {
                return this.customCell(row, feild);
            }
        });
    });

    this.setState({
        columns: columns,
        headers: headers,
    }, () => {
        this.initRows();
    });
  }

  initStepColumns = (dataFields = [], callback = null) => {
    let columnsSteps = [];

    let headers = [];

    if(this.state.importedSheetData && this.state.importedSheetData.length > 0){
        let heads = this.state.importedSheetData[0];
        headers = heads.map((head, i) => {
            let labelItem = dataFields.filter(x => x.value === head);

            return {
                value: head,
                label: (labelItem && labelItem.length > 0) ? labelItem[0].label : head,
            }
        });
    }

    dataFields.map((feild, i) => {
        let headerIndex = headers.findIndex(x => x.value === feild.value);
        if(headerIndex !== -1){
            feild.selected = feild.value;
        }

        if(feild.type === DataFieldType.Step){
            columnsSteps.push({ 
                field: feild.selected,
                realField: feild.value,
                title: <Box fontWeight={'bold'}>{feild.label}{((feild.required) ? <span className={'text-danger font-size-18'}>*</span> : '')}</Box>,
                required: feild.required,
                dataType: feild.dataType,
                colDB: feild.col,
                width: 200,
                sorting: false,
                searchable: false,
                grouping: false,
                filtering: false,
                render: (row, type) => {
                    return this.customCellSteps(row, feild);
                }
            });
        }
    });

    columnsSteps.push({ 
        title: "", 
        width: 'auto',
        sorting: false,
        searchable: false,
        grouping: false,
        filtering: false,
        action: true,
        render: (row) => {
            return <Box>
                {(this.state.rowsSteps && this.state.rowsSteps.length > 1) && <IconButton
                    onClick={() => {
                        this.removeStep(row.uuid);
                    }}
                >
                    <DeleteIcon />
                </IconButton>}
            </Box>
        }
    });

    this.setState({
        columnsSteps: columnsSteps,
    }, () => {
        if(callback){
            callback();
        }
    });
  }

  initRows = (callback = null) => {
    let excelRows = [];
    this.setState({
        isLoadingInitCalls: true,
    });

    if (this.state.importedSheetData && this.state.importedSheetData.length > 1) {
        excelRows = this.state.importedSheetData.map((item, i) => {
            if(i > 0){
                let row = this.state.importedSheetData[0].reduce((sum, key, index) => Object.assign(sum, { [key]: (item[index] == null || item[index] == '' || item[index].trim().length === 0) ? '' : item[index].trim() }), {});
                return row;
            } else {
                return null;
            }
        });
    }

    if(excelRows && excelRows.length > 0){
        excelRows.splice(0, 1);
    }
    let rows = this.initChangeColumns(excelRows);

    let errMessages = [] 

    if(rows.length < 1) {
        errMessages.push(`There is no driver`)
    }
      rows.forEach((row, i) => {
        if(row['First name'] === '' || row['First name'] === null) {
            
            errMessages.push(`First name is empty at row ${i+2}.`)
        }

        if(row['Vehicle number'] === '' || row['Vehicle number'] === null) {
            
            errMessages.push(`Vehicle number is empty at row ${i+2}.`)
        }
        
        if(row['Mobile number'] === '' || row['Mobile number'] === null) {
            
            errMessages.push(`Mobile number is empty at row ${i+2}.`)
        }

        if(row['Vehicle type'] === '' || row['Vehicle type'] === null) {
            
            errMessages.push(`Vehicle type is empty at row ${i+2}.`)
        }
        
        if(row['Category'] === '' || row['Category'] === null) {
            
            errMessages.push(`Category is empty at row ${i+2}.`)
        }
        
        if(row['Mobile number'] !== '' && !apiUtil.phoneValidation(row['Mobile number'])) {
            
            errMessages.push(`Mobile number is invalid at row ${i+2}.`)
        }
        
        if(row['Preferred payment method'] === '' || row['Preferred payment method'] === null) {
            
            errMessages.push(`Preferred payment method is empty at row ${i+2}.`)
        }
        
        if(row['PayNow / PayLah / Bank Account Number'] === '' || row['PayNow / PayLah / Bank Account Number'] === null) {
            
            errMessages.push(`PayNow / PayLah / Bank Account Number is empty at row ${i+2}.`)
        }
        
        if(row['Username'] === '' || row['Username'] === null) {
            
            errMessages.push(`Username is empty at row ${i+2}.`)
        }
        
        if(row['Password'] === '' || row['Password'] === null) {
            
            errMessages.push(`Password is empty at row ${i+2}.`)
        }
        
        if(row['Driver profile'] === '' || row['Driver profile'] === null) {
            
            errMessages.push(`Driver profile is empty at row ${i+2}.`)
        }
        
        if(row['Available hours (start)'] === '' || row['Available hours (start)'] === null) {
            
            errMessages.push(`Available hours (start) is empty at row ${i+2}.`)
        }
        
        if(row['Available hours (end)'] === '' || row['Available hours (end)'] === null) {
            
            errMessages.push(`Available hours (end) is empty at row ${i+2}.`)
        }
        
        let start_time = moment(row['Available hours (start)'],'hh:mm');
        let end_time = moment(row['Available hours (end)'],'hh:mm');
        let diff_time = end_time.diff(start_time, 'hours',true);
        if (row['Available hours (start)'] == row['Available hours (end)'] || diff_time < 0) {
            errMessages.push(`Invalid available time at row ${i+2}.`)
        }
        
      })
    
    this.setState({
        excelRows: excelRows,
        rows: rows,
        errMessages: errMessages,
        isLoadingInitCalls: false,
    }, () => {

        if(callback){
            callback();
        }
    });
  }


  formatDateField = (row, realField, dataType) => {
    let value = (row && realField && row[realField] && row[realField] !== '') ? row[realField] : '';

    if(dataType && dataType === 'date'){
        try {
            let date = moment(value);
            return (date.isValid()) ? date.format(apiUtil.getDefaultDateFormat()) : value;
        } catch(e) {
            return value
        }
    } else if(dataType && dataType === 'datetime'){
        try {
            let datetime = moment(value);
            return (datetime.isValid()) ? datetime.format(apiUtil.getDefaultDateFormat() + ' ' + this.state.timeFormat) : value;
        } catch(e) {
            return value
        }
    } else {
        return value
    }
  }


  initChangeColumns = (excelRows = []) => {
    let rows = [];
        if(excelRows && excelRows.length > 0){
            excelRows.map((row, i) => {
                let rowArray = [];
                let columns = JSON.parse(JSON.stringify(this.state.columns));

                let counter = 0;
                Object.entries(row).map(([ key, value ]) => {
                    let realKey = key;
                    if(this.state.dataFields && this.state.dataFields[counter] && this.state.dataFields[counter].value){
                        realKey = this.state.dataFields[counter].value;
                    };
                    let columnsIndex = columns.findIndex(x => x.realField === realKey);
                    if(columnsIndex !== -1){
                        if(columns[columnsIndex].realField && columns[columnsIndex].realField !== ''){
                            let dataType = columns[columnsIndex].dataType;
                            let realField = columns[columnsIndex].realField;
                            rowArray[realField] = this.formatDateField(row, realField, dataType);
                            rowArray[realField + '_validated'] = false;

                            columns.splice(columnsIndex, 1);
                        } else {
                            rowArray[realKey] = '';
                            rowArray[realKey + '_validated'] = false;
                        }
                    } else {
                        rowArray[realKey] = '';
                        rowArray[realKey + '_validated'] = false;
                    }
                    
                    counter++;
                });
                rows.push(Object.assign({}, rowArray));
            });
        }
        return rows;
  }

  changeColumns = (realField, selectedField) => {
    let excelRows = this.state.excelRows;
    let rows = this.state.rows;
    let newRows = [];
    if( realField == "Phone No." && selectedField == "Phone" ){
        if((rows && rows.length > 0) && (excelRows && excelRows.length > 0)){
            newRows = rows.map((row, i) => {
                row[realField] = (excelRows[i][selectedField] && excelRows[i][selectedField] !== '') ? excelRows[i][selectedField].replaceAll(" ","") : '';
                return row;
            });
        } 
    }else{ 
        if((rows && rows.length > 0) && (excelRows && excelRows.length > 0)){
            newRows = rows.map((row, i) => {
                row[realField] = (excelRows[i][selectedField] && excelRows[i][selectedField] !== '') ? excelRows[i][selectedField] : '';
                return row;
            });
        }
    }

    return newRows;
  }

  getForm(){
    let data = [];

    let rows = this.state.rows;
    if(rows && rows.length > 0){
        rows.forEach(objData => {
      
            let itemData = {
              first_name: objData['First name'],
              vehicle_number: objData['Vehicle number'],   
              vehicle_type: objData['Vehicle type'],  
              category: objData['Category'], 
              mobile_number: objData['Mobile number'] && objData['Mobile number'].length === 8 ? '+65' + objData['Mobile number'] : objData['Mobile number'],    
              preferred_payment_method: objData['Preferred payment method'],     
              bank_account_number: objData['PayNow / PayLah / Bank Account Number'],
              username: objData['Username'],
              password: objData['Password'],
              driver_profile: objData['Driver profile'],
              available_hour_from: objData['Available hours (start)'],
              available_hour_to: objData['Available hours (end)']                    
            }
      
            data.push(itemData);
          });
    }
    return data;
  }
  /* END FUNCTIONS */


  /* TABLE */
  customTableItems = () => {
    if(!this.state.isLoadingItems){
        return <Table 
            className={'import-table'}
            paging={false}
            isDraggable={false}
            tableLayout={'fixed'}
            data={this.state.rowsItems}
            columns={this.state.columnsItems}
            isLoading={this.state.isLoadingItems}
        />
    }
  }

  customTableSteps = () => {
      if(!this.state.isLoadingSteps){
        return <Table 
            className={'import-table'}
            paging={false}
            tableLayout={'fixed'}
            isDraggable={false}
            data={this.state.rowsSteps}
            columns={this.state.columnsSteps}
            isLoading={this.state.isLoadingSteps}
        />
      }
  }

  customTable = () => {
    return <Table 
        className={'import-table has-overflow'}
        Header={this.customHeader}
        paging={false}
        isDraggable={false}
        tableLayout={'fixed'}
        data={this.state.rows}
        columns={this.state.columns}
        maxBodyHeight={'500px'}
    />
  }

  customHeader = (props) => {
    let { isCustomerRequired } = this.context;

    return <thead className={'custom-head-thead'}>
        <tr className={'custom-head-tr'}>{props.columns.map((col, i) => {
                return (col.hidden === undefined ? <td key={i} className={'custom-head-th'} width={col.width}>
                    <Box>
                        {
                            (col.dataType === 'checkbox')
                            ?
                            <React.Fragment>
                                <CustomLabel 
                                    className={"custom-label"}
                                    label={<Box fontWeight={'bold'}>{col.title}{((col.required) ? <span className={'text-danger font-size-18'}>*</span> : '')}</Box>}
                                />
                                <CustomCheckbox
                                    label={(col.checked) ? 'Unmark All' : 'Mark All'}
                                    checked={true}
                                    onChange={(checked) => {
                                        if(this.state.isFirstTime){
                                            this.initRows(() => {
                                                col.checked = checked;
                                                let rows = this.state.rows;
                                                if(rows && rows.length > 0){
                                                    rows.map((item, i) => {
                                                        item[col.field] = checked;
                                                        item[col.colDB] = checked;
                                                        return item;
                                                    });
                                                }
                                                this.setState({
                                                    rows: rows,
                                                });
                                            })
                                        } else {
                                            col.checked = checked;
                                            let rows = this.state.rows;
                                            if(rows && rows.length > 0){
                                                rows.map((item, i) => {
                                                    item[col.field] = checked;
                                                    item[col.colDB] = checked;
                                                    return item;
                                                });
                                            }
                                            this.setState({
                                                rows: rows,
                                            });
                                        }
                                    }}
                                />
                            </React.Fragment>
                            :
                            (col.field === 'Company Code' && !isCustomerRequired) ? "" : 
                            <CustomSelectOption
                                className={'no-margin white'}
                                label={<Box fontWeight={'bold'}>{col.title}{((col.required) ? <span className={'text-danger font-size-18'}>*</span> : '')}</Box>}
                                placeholder={'Choose one'}
                                initFirstItem={true}
                                value={col.field}
                                items={this.state.headers}
                                onChange={(value, item) => {
                                    if(this.state.isFirstTime){
                                        this.initRows(() => {
                                            let columns = this.state.columns;
                                            let headers = this.state.headers;

                                            let selected = col.field;
                                            
                                            if(value !== 0){
                                                col.field = item.value;
                                                selected = col.field;
                                                col.isSelected = true;
                                            } else {
                                                col.field = '';
                                                selected = col.realField;
                                                col.isSelected = false;
                                            }

                                            columns[i] = col;
                                            let dataFieldsIndex = this.state.dataFields.findIndex(x => x.value === col.realField);
                                            if(dataFieldsIndex !== -1){
                                                this.dataFieldsPom[dataFieldsIndex].value = selected
                                            }
                                            
                                            this.setState({
                                                columns: columns,
                                                headers: headers,
                                            }, () => {
                                                let rows = this.changeColumns(col.realField, col.field);
                                                
                                                this.setState({
                                                    rows: rows,
                                                }, () => {
                                                    if((col.field !== '') && col.title === 'Recipient address'){
                                                        this.checkAddressApiCalls(col.realField);
                                                    } /*else if((col.field !== '') && col.title === 'Company code'){
                                                        this.checkCodeApiCalls(col.realField);
                                                    }*/

                                                    if(col.title === "Recipient address"){
                                                        let item = '';
                                                        let dataFields = this.state.dataFields;
                                                        let itemIndex = dataFields.findIndex(x => x.label === 'Recipient address');
                                                        let itemIndexAddress = dataFields.findIndex(x => x.col === 'address');
                                                        if(itemIndex !== -1){
                                                            item = col.field;
                                                            dataFields[itemIndexAddress].value = col.field;
                                                        }
                                                        
                                                        this.initStepColumns(dataFields, () => {
                                                            let rowsSteps = this.state.rowsSteps;
                                                            if(rowsSteps && rowsSteps.length > 0){
                                                                rowsSteps = rowsSteps.map((step, i) => {
                                                                    step[item] = item;
                                                                    return step;
                                                                });
                                                                this.setState({
                                                                    rowsSteps: rowsSteps,
                                                                });
                                                            }
                                                        });
                                                    }
                                                });
                                            });
                                        });
                                    } else {
                                        let columns = this.state.columns;
                                        let headers = this.state.headers;

                                        let selected = col.field;
                                        
                                        if(value !== 0){
                                            col.field = item.value;
                                            selected = col.field;
                                            col.isSelected = true;
                                        } else {
                                            col.field = '';
                                            selected = col.realField;
                                            col.isSelected = false;
                                        }

                                        columns[i] = col;

                                        let dataFieldsIndex = this.state.dataFields.findIndex(x => x.value === col.realField);
                                        if(dataFieldsIndex !== -1){
                                            this.dataFieldsPom[dataFieldsIndex].value = selected
                                        }
                                        
                                        this.setState({
                                            columns: columns,
                                            headers: headers,
                                        }, () => {
                                            let rows = this.changeColumns(col.realField, col.field);
                                            
                                            this.setState({
                                                rows: rows,
                                            }, () => {
                                                if((col.field !== '') && col.title === 'Recipient address'){
                                                    this.checkAddressApiCalls(col.realField);
                                                } /*else if((col.field !== '') && col.title === 'Company code'){
                                                    this.checkCodeApiCalls(col.realField);
                                                }*/

                                                if(col.title === "Recipient address"){
                                                    let item = '';
                                                    let dataFields = this.state.dataFields;
                                                    let itemIndex = dataFields.findIndex(x => x.label === 'Recipient address');
                                                    let itemIndexAddress = dataFields.findIndex(x => x.col === 'address');
                                                    if(itemIndex !== -1){
                                                        item = col.field;
                                                        dataFields[itemIndexAddress].value = col.field;
                                                    }

                                                    this.initStepColumns(dataFields, () => {
                                                        let rowsSteps = this.state.rowsSteps;
                                                        if(rowsSteps && rowsSteps.length > 0){
                                                            rowsSteps = rowsSteps.map((step, i) => {
                                                                step[item] = item;
                                                                return step;
                                                            });

                                                            this.setState({
                                                                rowsSteps: rowsSteps,
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        });
                                    }
                                }}
                            />
                        }
                    </Box>
                </td> : "")
            })}</tr>
    </thead>
  }

  customCell = (row, feild, i) => {
    let { isCustomerRequired } = this.context;
    row[feild.value + '_validated'] = (row[feild.value] && row[feild.value] !== '') ? false : feild.required;// this.unRequiredFileldUti(feild.label, feild.required);
    let isError = (feild.required) ? row[feild.value + '_validated'] : false;
    isError = ((isError === false) || (isError === true)) ? isError : false;
    let isSelected = this.state.columns[i] !== undefined ? this.state.columns[i].isSelected : false;

    if(isSelected){
        return <Box>
            {
                /* Company code is not mandotory */
                /*(feild.label === 'Company code')
                ?
                (isCustomerRequired ?
                <CustomInput
                    className={'no-margin'}
                    placeholder={feild.label}
                    value={row[feild.value]}
                    required={feild.required}
                    error={(!row.isValidCode && row.hasCheck) ? true : isError}
                    onChange={(e) => {
                        row[feild.value] = e.target.value;
                        row[feild.value + '_validated'] = (e.target.value !== '') ? false : feild.required;
                    }}
                    onBlur={() => {
                        this.setState({
                            isLoading: true,
                        }, () => {
                            this.asyncCallCheckCompanyCodeApi(row, feild.value).then((results) => {
                                row['isValidCode'] = results;
                                row['hasCheck'] = true;

                                this.setState({
                                    isLoading: false,
                                });
                            }).catch((e) => {
                                this.setState({
                                    isLoading: false,
                                });
                            })
                        });
                    }}
                />
                : "")
                :*/
                (feild.label === 'Recipient address')
                ?
                <CustomGoogleMapSearch
                    className={'no-margin'}
                    placeholder={feild.label}
                    value={row[feild.value]}
                    required={feild.required}
                    error={isError}
                    onChange={(e) => {
                        let value = (e.target.value && e.target.value !== '') ? e.target.value : '';
                        
                        row[feild.value] = value;
                        row[feild.value + '_validated'] = (value !== '') ? false : feild.required;

                        if(value === ''){
                            row['coord'] = null;

                            let rows = this.state.rows;
                            rows[row.tableData.id] = row;
                            this.setState({
                                rows: rows
                            });
                        }
                    }}
                    onPlacesChanged={(place) => {
                        if(place){
                            let address = apiUtil.getGmapAddress(place);
                            
                            row[feild.value] = address;
                            row[feild.value + '_validated'] = feild.required;
                            
                            this.callGeoCoderAddressApi(address, (data) => {
                                if(data){
                                    row['coord'] = {
                                        lat: data.lat,
                                        lng: data.lng,
                                    };
                                }

                                let rows = this.state.rows;
                                rows[row.tableData.id] = row;
                                this.setState({
                                    rows: rows
                                });
                            });
                        } else {
                            row[feild.value] = '';
                            row[feild.value + '_validated'] = feild.required;
                            row['coord'] = null;

                            let rows = this.state.rows;
                            rows[row.tableData.id] = row;
                            this.setState({
                                rows: rows
                            });
                        }
                    }}
                />
                :
                (feild.dataType === 'checkbox')
                ?
                <CustomCheckbox
                    label={feild.label}
                    checked={row[feild.value]}
                    onChange={(checked) => {
                        row[feild.value] = checked;
                    }}
                />
                :
                <CustomInput
                    className={'no-margin'}
                    placeholder={feild.label}
                    value={row[feild.value]}
                    required={feild.required}
                    error={isError}
                    onChange={(e) => {
                        row[feild.value] = e.target.value;
                        row[feild.value + '_validated'] = (e.target.value !== '') ? false : feild.required;
                    }}
                />
            }
        </Box>;
    } else {
        return <Box></Box>
    }
  }

  customCellSteps = (row, feild) => {
    row[feild.value + '_validated'] = (row[feild.value] && row[feild.value] !== '') ? false : feild.required;
    let isError = (feild.required) ? row[feild.value + '_validated'] : false;
    
    return <Box>
        {
            (feild.dataType === 'checkbox')
            ?
            <CustomCheckbox
                label={feild.label}
                checked={feild.label === "Require signature"? true : row[feild.value]}
                onChange={(checked) => {
                    row[feild.value] = checked;
                    row[feild.col] = checked;
                }}
            />
            :
            <CustomSelectOption
                className={'no-margin white'}
                placeholder={'Choose one'}
                initFirstItem={true}
                value={row[feild.value]}
                items={this.state.headers}
                required={feild.required}
                error={isError}
                onChange={(value, item) => {
                    let columns = this.state.columns;
                    let headers = this.state.headers;
                    
                    let selected = feild.value;

                    if(value !== 0){
                        row[feild.col] = item.value;
                        row[feild.value] = item.value;
                        row[feild.value + '_validated'] = false;
                        selected = row[feild.value];
                    } else {
                        row[feild.col] = '';
                        row[feild.value] = '';
                        row[feild.value + '_validated'] = feild.required;
                    }

                    let dataFieldsIndex = this.state.dataFields.findIndex(x => x.value === feild.value);
                    if(dataFieldsIndex !== -1){
                        this.dataFieldsPom[dataFieldsIndex].value = selected
                    }
                    
                    this.setState({
                        columns: columns,
                        headers: headers,
                    });
                }}
            />
        }
    </Box>;
  }

  customCellItems = (row, feild) => {
    row[feild.value + '_validated'] = (row[feild.value] && row[feild.value] !== '') ? false : feild.required;
    let isError = (feild.required) ? row[feild.value + '_validated'] : false;
    
    return <Box>
        {
            (feild.dataType === 'checkbox')
            ?
            <CustomCheckbox
                label={feild.label}
                checked={row[feild.value]}
                onChange={(checked) => {
                    row[feild.value] = checked;
                    row[feild.col] = checked;
                }}
            />
            :
            <CustomSelectOption
                className={'no-margin white'}
                placeholder={'Choose one'}
                initFirstItem={true}
                value={row[feild.value]}
                items={this.state.headers}
                required={feild.required}
                error={isError}
                onChange={(value, item) => {
                    let columns = this.state.columns;
                    let headers = this.state.headers;

                    let selected = feild.value;

                    if(value !== 0){
                        row[feild.col] = item.value;
                        row[feild.value] = item.value;
                        row[feild.value + '_validated'] = false;
                        selected = row[feild.value];
                    } else {
                        row[feild.col] = '';
                        row[feild.value] = '';
                        row[feild.value + '_validated'] = feild.required;
                    }

                    let dataFieldsIndex = this.state.dataFields.findIndex(x => x.value === feild.value);
                    if(dataFieldsIndex !== -1){
                        this.dataFieldsPom[dataFieldsIndex].value = selected
                    }

                    this.setState({
                        columns: columns,
                        headers: headers,
                    });
                }}
            />
        }
    </Box>;
  }
  /* END TABLE */


  /* FORM */
  isValid = (callback = null) => {
    let state = true;

    let rows = this.state.rows;
    if(rows && rows.length > 0){
        for(let i = 0; i < rows.length; i++){
            if(callback !== null){
                state = callback(state, rows[i]);
                if(!state)
                    break;
            }
        };
    }

    return state;
  }

  setError = () => {
    const { isCustomerRequired } = this.context;
    if (isCustomerRequired) {
      let state = this.isValid((isValidCode = true, item) => {
          if((!item.isValidCode || item.isValidCode === null || item.isValidCode === undefined || item.isValidCode === '') && item.hasCheck){
              isValidCode = false;
          }

          return isValidCode;
      });

      let isSelected = false;
      if(this.state.columns && this.state.columns.length > 0){
          let companyCodeItem = this.state.columns.filter(x => x.title === 'Company code');
          if(companyCodeItem && companyCodeItem.length > 0){
              isSelected = (companyCodeItem[0].field && companyCodeItem[0].field !== '') ? true : false;
          }
      }

      if(isSelected && !state){
          return <Box clone pt={1} pb={1}>
              <Grid item xs={12}>
                  <CustomAlert
                      color={'error'}
                      icon={<FontAwesomeIcon icon={faCircleInfo} />}
                  >
                      Invalid company code. Please create the missing company codes or the system won't be able to import their jobs.
                  </CustomAlert>
              </Grid>
          </Box>
      }
    }
  }

  setNewError = () => {
    const errMessages = this.state.errMessages
      if(errMessages.length > 0) {
          return <Box clone pt={1} pb={1}>
            <Grid item xs={12}>
                {errMessages.map((err) => (
                <Box style={{margin:'1px'}}>
                  <CustomAlert
                      color={'error'}
                      icon={<FontAwesomeIcon icon={faCircleInfo} />}
                  >
                      {err}
                  </CustomAlert>
                  </Box>
                  ))} 
              </Grid>
            
              
          </Box>
      } 
    
  }

  setWarning = () => {
    let state = this.isValid((isValidCoord = true, item) => {
        if(!item.coord || item.coord === null || item.coord === undefined || (!item.coord.lat || !item.coord.lng)){
            isValidCoord = false;
        }

        return isValidCoord;
    });

    let isSelected = false;
    if(this.state.columns && this.state.columns.length > 0){
        let recipientAddressItem = this.state.columns.filter(x => x.title === 'Recipient address');
        if(recipientAddressItem && recipientAddressItem.length > 0){
            isSelected = (recipientAddressItem[0].field && recipientAddressItem[0].field !== '') ? true : false;
        }
    }

    if(isSelected && !state){
        return <Box clone pt={1} pb={1}>
            <Grid item xs={12}>
                <CustomAlert
                    color={'warning'}
                    icon={<FontAwesomeIcon icon={faCircleInfo} />}
                >
                    There are some addresses that we could not recognize. You can still import the job but we would not be able to give coordinates to your driver(s).
                </CustomAlert>
            </Grid>
        </Box>
    }
    return false
  }

  setForm = () => {
    return <Box>
        <Grid container>
            <Box clone pb={1}>
                <Grid item xs={12}>
                    <CustomLabel
                        className={'no-margin'}
                        label={<Box fontWeight={'bold'}>Match your uploaded sheet headers to our form. Fields marked with <span className={'text-danger font-size-18'}>*</span> is mandatory.</Box>}
                        size={'md'}
                    />
                    <CustomLabel
                        className={'no-margin'}
                        label={'You may perform changes to your customer details in the columns below.'}
                        size={'sm'}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    {this.customTable()}
                </Grid>
            </Box>
            <Box clone pt={2} pb={1}>
                <Grid item xs={12}>
                    <Box>
                        <Grid container alignItems={'center'}>
                            <Box clone>
                                <Grid item xs={12} md={true}>
                                    <CustomLabel
                                        className={'no-margin'}
                                        label={'JOB STEPS'}
                                        size={'lg'}
                                        weight={'bold'}
                                    />
                                    <CustomLabel
                                        className={'no-margin'}
                                        label={<Box>Each step added here represents an <span style={{ fontWeight: 'bold' }}>step per job</span>. No preview available.</Box>}
                                        size={'md'}
                                    />
                                </Grid>
                            </Box>
                            <Box clone>
                                <Grid item xs={12} md={'auto'}>
                                    <CustomButton 
                                        color={'primary'}
                                        variant={'outlined'}
                                        onClick={() => {
                                            this.addStepBtn();
                                        }}
                                    >
                                        Add Step
                                    </CustomButton>
                                </Grid>
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    {this.customTableSteps()}
                </Grid>
            </Box>
            <Box clone pt={2} pb={1}>
                <Grid item xs={12}>
                    <Box>
                        <Grid container alignItems={'center'}>
                            <Box clone>
                                <Grid item xs={12} md={true}>
                                    <CustomLabel
                                        className={'no-margin'}
                                        label={'ITEMS (PER JOB)'}
                                        size={'lg'}
                                        weight={'bold'}
                                    />
                                    <CustomLabel
                                        className={'no-margin'}
                                        label={<Box>Each item added here represents an <span style={{ fontWeight: 'bold' }}>item per job</span>. No preview available.</Box>}
                                        size={'md'}
                                    />
                                </Grid>
                            </Box>
                            <Box clone>
                                <Grid item xs={12} md={'auto'}>
                                    <CustomButton 
                                        color={'primary'}
                                        variant={'outlined'}
                                        onClick={() => {
                                            this.addItem();
                                        }}
                                    >
                                        Add Item
                                    </CustomButton>
                                </Grid>
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    {this.customTableItems()}
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  
  setButtons = () => {
    return <Box>
        <Grid container alignItems={'center'} >
            <Box clone textAlign={'right'} pr={2}>
                <Grid item xs={true}>
                    <CustomButton 
                    className="text-dark-cancel"
                        onClick={() => {
                            if(this.props.onClose){
                                this.props.onClose();
                            }
                        }}
                    >
                        Cancel
                    </CustomButton>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={'auto'}>
                    <CustomButton 
                        type={'submit'}
                        color={'secondary'}
                        disabled={this.state.errMessages.length > 0 || this.setWarning() == true ? true : false}
                        isLoading={this.state.isLoading}
                    >
                        Confirm
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    </Box>
  }

  setIsLoading = () => {
      if(this.state.isLoadingInitCalls){
        return <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'35vh'} width={'100%'}>
            <CircularProgress size={55} />
        </Box>
      } else {
        return <React.Fragment>
            {this.setError()}
            {this.setNewError()}
            {this.setWarning()}
            <Box clone pt={2} pb={2}>
                <Grid item xs={12}>
                    {/* {this.setForm()} */}
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    {this.setButtons()}
                </Grid>
            </Box>
        </React.Fragment>
      }
  }
  /* END FORM */


  /* SUBMIT */
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    
    
    if (form.checkValidity() === true ) {

        if(this.props.onImport){
            this.props.onImport(this.getForm());
        }
    } else {
        this.setState({
            isLoading: false
        }, () => {
            
                apiUtil.toast('There are some field(s) which are empty. Please fill in these empty fields to continue.', 'check_circle', 'error');

        });
    }
  }
  /* END SUBMIT */


  render() {
    return <Box>
        <form noValidate autoComplete="off" onSubmit={this.handleSubmit} ref={f => (this.refForm = f)}>
            <Grid container>
                {this.setIsLoading()}
            </Grid>
        </form>
    </Box>
  }
}

export default JobImportDialog;